import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { ChairpersonResetPasswordForm } from '@/components/auth/chairperson-reset-password'
import { routeToRedirectUrl } from '@/utils'
import { ROUTES, STORAGE_KEYS } from '@/constants'
import { localStorageService } from '@/services'

export const ChairpersonResetPasswordPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const redirectUrl = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)
    const fromUrl = searchParams.get(STORAGE_KEYS.REDIRECT_URL)
    if (fromUrl) return fromUrl
    return localStorageService.getItem(STORAGE_KEYS.REDIRECT_URL) || null
  }, [location.search])

  const handleSuccess = () => {
    const urlToRedirect =
      redirectUrl || localStorageService.getItem(STORAGE_KEYS.REDIRECT_URL)
    if (urlToRedirect) {
      localStorageService.removeItem(STORAGE_KEYS.REDIRECT_URL)
      routeToRedirectUrl(urlToRedirect)
    } else {
      navigate(ROUTES.CHAIRPERSON_DASHBOARD)
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <ChairpersonResetPasswordForm
        variant='page'
        showRequiredMessage={true}
        onSuccess={handleSuccess}
      />
    </Box>
  )
}
